export const ABIERTO = 'ABI'
export const ANULADO = 'ANU'
export const CERRADO = 'CER'
export const PROCESADO = 'PRO'

// Nuevos estados - Flujo Requerimientos v2
export const BORRADOR = 'BOR'
export const PENDIENTE_APROBACION_JEFE = 'PAJ'
export const EN_REVISION = 'REV'
export const ELEVADO_A_GERENCIA = 'ELE'
export const APROBADO_POR_GERENCIA = 'APG'
export const CAJA_CHICA = 'CCH'
export const EN_COTIZACION = 'COT'
export const CON_ORDEN_DE_COMPRA = 'COC'
export const POR_RECIBIR = 'PRE'
export const EN_ALMACEN = 'EAL'
export const ATENDIDO_DESDE_ALMACEN = 'ADA'
export const ATENDIDO_PARCIALMENTE = 'APA'
export const OBSERVADO = 'OBS'
export const RECHAZADO = 'REC'

export const __dictionary = {
  [ABIERTO]: {
    id: ABIERTO,
    nombre: 'PEND. REVISIÓN'
  },
  [ANULADO]: {
    id: ANULADO,
    nombre: 'ANULADO'
  },
  [CERRADO]: {
    id: CERRADO,
    nombre: 'CERRADO'
  },
  [PROCESADO]: {
    id: PROCESADO,
    nombre: 'PROCESADO'
  },
  [BORRADOR]: {
    id: BORRADOR,
    nombre: 'BORRADOR',
    color: 'secondary'
  },
  [PENDIENTE_APROBACION_JEFE]: {
    id: PENDIENTE_APROBACION_JEFE,
    nombre: 'PEND. APROBACIÓN JEFE',
    color: 'info'
  },
  [EN_REVISION]: {
    id: EN_REVISION,
    nombre: 'EN REVISIÓN',
    color: 'info'
  },
  [ELEVADO_A_GERENCIA]: {
    id: ELEVADO_A_GERENCIA,
    nombre: 'ELEVADO A GERENCIA',
    color: 'warning'
  },
  [APROBADO_POR_GERENCIA]: {
    id: APROBADO_POR_GERENCIA,
    nombre: 'APROBADO POR GERENCIA',
    color: 'success'
  },
  [CAJA_CHICA]: {
    id: CAJA_CHICA,
    nombre: 'CAJA CHICA',
    color: 'warning'
  },
  [EN_COTIZACION]: {
    id: EN_COTIZACION,
    nombre: 'EN COTIZACIÓN',
    color: 'primary'
  },
  [CON_ORDEN_DE_COMPRA]: {
    id: CON_ORDEN_DE_COMPRA,
    nombre: 'CON ORDEN DE COMPRA',
    color: 'primary'
  },
  [POR_RECIBIR]: {
    id: POR_RECIBIR,
    nombre: 'POR RECIBIR',
    color: 'info'
  },
  [EN_ALMACEN]: {
    id: EN_ALMACEN,
    nombre: 'EN ALMACÉN',
    color: 'success'
  },
  [ATENDIDO_DESDE_ALMACEN]: {
    id: ATENDIDO_DESDE_ALMACEN,
    nombre: 'ATENDIDO DESDE ALMACÉN',
    color: 'success'
  },
  [ATENDIDO_PARCIALMENTE]: {
    id: ATENDIDO_PARCIALMENTE,
    nombre: 'ATENDIDO PARCIALMENTE',
    color: 'warning'
  },
  [OBSERVADO]: {
    id: OBSERVADO,
    nombre: 'OBSERVADO',
    color: 'warning'
  },
  [RECHAZADO]: {
    id: RECHAZADO,
    nombre: 'RECHAZADO',
    color: 'danger'
  }
}

export const __array = [
  __dictionary[ABIERTO],
  __dictionary[ANULADO],
  __dictionary[CERRADO],
  __dictionary[PROCESADO],
  __dictionary[BORRADOR],
  __dictionary[PENDIENTE_APROBACION_JEFE],
  __dictionary[EN_REVISION],
  __dictionary[ELEVADO_A_GERENCIA],
  __dictionary[APROBADO_POR_GERENCIA],
  __dictionary[CAJA_CHICA],
  __dictionary[EN_COTIZACION],
  __dictionary[CON_ORDEN_DE_COMPRA],
  __dictionary[POR_RECIBIR],
  __dictionary[EN_ALMACEN],
  __dictionary[ATENDIDO_DESDE_ALMACEN],
  __dictionary[ATENDIDO_PARCIALMENTE],
  __dictionary[OBSERVADO],
  __dictionary[RECHAZADO]
]

export const __arrayFlujoV2 = [
  __dictionary[BORRADOR],
  __dictionary[PENDIENTE_APROBACION_JEFE],
  __dictionary[ABIERTO],
  __dictionary[EN_REVISION],
  __dictionary[ELEVADO_A_GERENCIA],
  __dictionary[APROBADO_POR_GERENCIA],
  __dictionary[CAJA_CHICA],
  // EN_COTIZACION removido del flujo
  __dictionary[CON_ORDEN_DE_COMPRA],
  __dictionary[ATENDIDO_PARCIALMENTE],
  __dictionary[POR_RECIBIR],
  __dictionary[EN_ALMACEN],
  __dictionary[ATENDIDO_DESDE_ALMACEN],
  __dictionary[OBSERVADO],
  __dictionary[RECHAZADO],
  __dictionary[CERRADO]
]
